import { cn } from "../lib/utils";
import { NavBadge } from "./left-rail";
import { DefaultLink, type NavItem, type NavLinkComponent } from "./nav";

type BottomTabsProps = {
	items: NavItem[];
	activeKey: string | undefined;
	label: string;
	linkComponent?: NavLinkComponent;
	className?: string;
};

/** Bottom tabs for screens under 768 px. Each tab is at least 56 px tall. */
export function BottomTabs({
	items,
	activeKey,
	label,
	linkComponent: Link = DefaultLink,
	className,
}: BottomTabsProps) {
	return (
		<nav
			aria-label={label}
			data-slot="bottom-tabs"
			className={cn(
				"fixed inset-x-0 bottom-0 z-40 border-t bg-background pb-[env(safe-area-inset-bottom)] md:hidden",
				className,
			)}
		>
			<ul className="flex">
				{items.map((item) => {
					const active = item.key === activeKey;
					const Icon = item.icon;
					return (
						<li key={item.key} className="flex-1">
							<Link
								href={item.href}
								aria-current={active ? "page" : undefined}
								className={cn(
									"relative flex min-h-14 flex-col items-center justify-center gap-0.5 px-1 text-xs font-medium text-muted-foreground outline-none focus-visible:ring-3 focus-visible:ring-ring/50",
									active && "text-primary",
								)}
							>
								<Icon className="size-6" aria-hidden />
								<span>{item.label}</span>
								{item.badge ? <NavBadge count={item.badge} rail /> : null}
							</Link>
						</li>
					);
				})}
			</ul>
		</nav>
	);
}
